import { CustomComponentProps, GeneralColors } from "utils/types/generalTypes";

export type SwitchProps = CustomComponentProps & {
    checked?: boolean;
    color?: GeneralColors;
    disabled?: boolean;
};

const Switch = ({
    checked = false,
    color = "is-primary",
    disabled = false,
    handleClick,
    className,
    style
}: SwitchProps) => {
    return (
        <label
            className={`f-switch ${color} ${checked ? "checked" : ""} ${
                disabled ? "is-disabled" : ""
            } ${className}`}
            style={style}
        >
            <i onClick={() => handleClick && handleClick()}></i>
        </label>
    );
};

export default Switch;
